module.exports = __webpack_public_path__ + "media/11_11.4beabc3f.wav";